import React, {useState} from 'react';
import Compress from 'compress.js';

export default function LaunchGallery({onSelectImage}) {
  const [inputKey, setInputKey] = useState(0);

  // تبدیل base64 به File
  const base64ToFile = (base64, filename, type) => {
    const arr = base64.split(',');
    const mime = type || arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, {type: mime});
  };

  const handleFileChange = async event => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      let uploadFile = file;
      let uri = '';

      const fileSizeInMB = file.size / (1024 * 1024);

      if (fileSizeInMB > 3) {
        // فشرده سازی فایل‌های بزرگ
        const compress = new Compress();
        const results = await compress.compress([file], {
          size: 3, // حداکثر 3 مگابایت
          quality: 0.7,
          maxWidth: 1920,
          maxHeight: 1920,
        });

        const compressed = results[0];
        uri = compressed.prefix + compressed.data;
        uploadFile = base64ToFile(uri, file.name, file.type);
      } else {
        // فایل کوچک، بدون فشرده سازی
        const reader = new FileReader();
        uri = await new Promise((resolve, reject) => {
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      }

      onSelectImage({
        uri,
        type: file.type,
        name: file.name,
        file: uploadFile,
        uploadData: uri,
      });
    } catch (error) {
      console.error('Error processing image:', error);
      onSelectImage(null);
    } finally {
      // تغییر key برای reset input و اجازه انتخاب دوباره همان فایل
      setInputKey(prev => prev + 1);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
      {/* هک مخصوص Chrome/  accept="image/*,android/allowCamera" */}
      <input
        key={inputKey}
        type="file"
        accept="image/*,android/allowCamera"
        onChange={handleFileChange}
        style={{
          width: '100%',
          height: 54,
          zIndex: 1000,
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          cursor: 'pointer',
        }}
      />
    </div>
  );
}
